var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',{staticClass:"pt-0"},_vm._l((_vm.routeRenderedInSideBar),function(route){return _c('NavigationItem',{key:route.name,attrs:{"route":route}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }